import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import Img from "../../../images/podcast/ep-1.png";
import {LazyLoadImage} from "react-lazy-load-image-component";


function Banner({data}) {
    return (

        <div className="services_banner ">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={7} lg={7} xl={7} xxl={7} className="my-auto">
                        <div className="example" data-text="Tek Podcast">
                            <h1>c</h1>
                        </div>
                        <div
                            className="banner_content_txt listing_flex">
                            <p>Listen to the discussion on technological affairs in the GCC in our latest podcast release, where our host Hady Shaikh, Principal Product Strategist at TekRevol, has an insightful discussion with Derek Watson, Founder of N2 Technology Ltd, a Market Network for the distribution and sourcing of Startup investments and opportunities.</p>
                        </div>
                    </Col>
                    <Col xs={12} md={5} lg={5} xl={5} xxl={5} className="my-auto text-center">
                        <LazyLoadImage
                            src={Img}
                            effect="blur" alt="Image" className="img-fluid"
                        />
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Banner;